module.exports = __webpack_public_path__ + "media/images/NewBMP_mobile-798e6f60f9d1743570feccf49e7a89d5.jpg";